import {useState, useRef, useCallback} from 'react';
import {entities, itControlApproachType} from '../../../../../../../util/uiconstants';
import {labels} from '../../../../../../../util/utils';
import {
	filterByName,
	listHeaders
} from '../../../../../../Main/Forms/Body/CanvasForm/ManageObjects/ManageObjectsModal.utils';
import {mapItControlsResponse, mapTasksResponse} from './mapResponses';
import {relateItControl, unRelateItControl} from '../../../../../../../actions/ITRisk/itriskactions';
import {
	getEngagementAllItControls,
	refreshUnrelatedItControls
} from '../../../../../../../actions/ITControl/itcontrolaction';
import {getAllTasksByCriteria} from '../../../../../../../actions/Task/getalltasksaction';
import {relateTask, unrelateTask} from '../../../../../../../actions/ITProcess/itprocessactions';

const commonConfig = {
	modalSize: 'medium',
	isServerSidePaged: true,
	pagination: true,
	pageSize: 20,
	checkBox: true,
	filter: filterByName
};

const RelateEntitiesConfig = {
	[entities.ItControl]: ({itApproachTypeId = itControlApproachType.controls}) => {
		const isITGC = itApproachTypeId === itControlApproachType.controls;
		return {
			title: isITGC ? labels.relateItGcTitle : labels.relateITSPTitle,
			description: isITGC ? labels.relateItGcDescription : labels.relateITSPDescription,
			parentEntityLabel: labels.relateItGcEntityTitle,
			parentEntityName: (item) => item.itRiskName,
			showSelectedOnlyText: isITGC ? labels.relateItGcShowSelectedOnlyText : labels.relateITSPShowSelectedOnlyText,
			searchPlaceholder: isITGC ? labels.relateItGcSearchPlaceholder : labels.relateITSPSearchPlaceholder,
			noResultsLabel: labels.noResultFound,
			noDataLabel: isITGC ? labels.relateItGcNoDataPlaceholder : labels.relateITSPNoDataPlaceholder,
			isServerSidePaged: false,
			fetchAction: (engagementId, includePagination = true) =>
				getEngagementAllItControls(engagementId, undefined, {
					itApproachTypeId: itApproachTypeId,
					includePagination: includePagination
				}),
			mapResponse: mapItControlsResponse,
			listHeaders: (totalEntityCount, showing) =>
				listHeaders(
					showing !== undefined ? showing : totalEntityCount,
					isITGC ? labels.itGcCount : labels.itSpCount,
					isITGC ? labels.iTGCName : labels.itSPName
				),
			// render: (item) => render, // Item component. Use if you need to show a custom item component
			// Returns an API action for the "relate endpoint"
			onRelateItem: (engagementId, parentId, item) => relateItControl(engagementId, parentId, item.id),
			// Returns an API action for the "un-relate endpoint"
			onUnrelateItem: (engagementId, parentId, item) => unRelateItControl(engagementId, parentId, item.id),
			// Can be a function or an action creator. In the later case, RelateEntitiesContainer will dispatch it
			onModalHide: (bodyId) => refreshUnrelatedItControls(bodyId)
		};
	},
	[entities.Task]: () => {
		return {
			title: labels.relateUDP,
			description: labels.relateUDPDescription,
			parentEntityName: (item) => item.itProcessName,
			searchPlaceholder: labels.relateUDPSearchPlaceholder,
			noResultsLabel: labels.relateUDPNoResultsFoundPlaceholder,
			noDataLabel: labels.relateUDPNoDataFoundPlaceholder,
			showSelectedOnlyText: labels.relateUDPShowOnlyRelatedTasks,
			modalCloseTitle: labels.modalCloseTitle,
			isServerSidePaged: false,
			fetchAction: (engagementId) =>
				getAllTasksByCriteria(engagementId, {
					categoryId: 2,
					subCategoryId: 1,
					tasktype: 19,
					orderBy: 'taskname',
					orderByAscending: true,
					includePagination: false,
					pageSize: 2000,
					includeuielements: false,
					includebookmarks: false
				}),
			mapResponse: mapTasksResponse,
			listHeaders: (totalEntityCount, showing) =>
				listHeaders(
					showing !== undefined ? showing : totalEntityCount,
					labels.relateUDPCountLabel,
					labels.relateUDPListHeaderItemName
				),
			// render: (item) => render, // Item component. Use if you need to show a custom item component
			// Returns an API action for the "relate endpoint"
			onRelateItem: (engagementId, parentId, item) => relateTask(engagementId, parentId, item.id),
			// Returns an API action for the "un-relate endpoint"
			onUnrelateItem: (engagementId, parentId, item) => unrelateTask(engagementId, parentId, item.id)
		};
	}
};

export function useRelateEntitiesModal() {
	const [containerProps, setContainerProps] = useState({});
	const modalRef = useRef();

	const openRelateModal = useCallback(
		(clickArgs) => {
			if (modalRef.current.toggleModal) {
				setContainerProps(clickArgs);
				modalRef.current.toggleModal();
			}
		},
		[modalRef]
	);

	return [containerProps, modalRef, openRelateModal];
}

export function getConfigurationForEntity(entityId, props) {
	let config = null;

	if (RelateEntitiesConfig[entityId]) {
		config = RelateEntitiesConfig[entityId](props);
	}
	if (config) {
		// Default configuration, merged with specific configuration for entityId
		return {
			...commonConfig,
			...config
		};
	}
}
